import "./Title.scss"

const Title = (props) => {

	return (
		<div>
			<h2 className="sectionTitle">{props.title}</h2>
		</div>
	)
}

export default Title;
